/**
 * Environment configuration data
 * Extracted from legacy choco-admin-portal system
 */

import { EnvironmentConfig, EnvironmentKey } from './types';

export const ENVIRONMENT_CONFIGS: Record<EnvironmentKey, EnvironmentConfig> = {
  // Main staging environment
  chostg: {
    emoji: '🥤',
    name: 'Staging',
    appSyncUrl:
      'https://i5ikxhkptvbktlr7agoht2mn4y.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_NxbzoMbLF',
    identityPoolId: 'eu-west-1:d717ca60-2a3e-4e1c-bbd0-77298b70ae05',
    userPoolWebClientId: '6etad5sggc8c6mnge85oo1kj9j',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chostg.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Saturn environment
  chocosaturn: {
    emoji: '🪐',
    name: 'Saturn',
    appSyncUrl:
      'https://64rbsjxo7vcldhc7cg72fgmbbq.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_4G7l4xz6d',
    identityPoolId: 'eu-west-1:bbdf07fc-b70a-4fb9-aef1-76a0fb22fae4',
    userPoolWebClientId: '3jpgdvpql1gvfj2uifkfnhuj9b',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chocosaturn.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Dusk environment
  chodusk: {
    emoji: '🌆',
    name: 'Dusk',
    appSyncUrl:
      'https://klwcpcvkxbb65cbnrfqfr4qjbm.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_w9dK7TJPl',
    identityPoolId: 'eu-west-1:d45c0ff1-6df8-4316-b2f9-c33e8b37ed20',
    userPoolWebClientId: '2vmm7jjft6elbq0rk5p7cqo7p6',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chodusk.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Zoo environment
  chocozoo: {
    emoji: '🦁',
    name: 'Zoo',
    appSyncUrl:
      'https://hqkb4k2n4fa2rj2xovb6y767ba.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_nWD1mHhVz',
    identityPoolId: 'eu-west-1:4cdb5b02-a5c7-4aca-8325-14fac8b3e6f6',
    userPoolWebClientId: '6vn6ijuqt4e02uq65d7cmnp26e',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chocozoo.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Winter environment
  chowinter: {
    emoji: '☃️',
    name: 'Winter',
    appSyncUrl:
      'https://hzwwm2xjzng3no7ktj5wg36ium.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_7M9nfQ66r',
    identityPoolId: 'eu-west-1:ae51b3e5-bd3a-412a-9aa3-5f63c8a5cab3',
    userPoolWebClientId: '5d8e67h2lv4npkrsvlhimgfq92',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chowinter.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Autumn environment
  chocoautumn: {
    emoji: '🍁',
    name: 'Autumn',
    appSyncUrl:
      'https://e5v6fulgt5byxi4luvanf5rx3e.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_lRDdeQaxy',
    identityPoolId: 'eu-west-1:e3a14e2e-9e83-46dc-af32-7bdf84840946',
    userPoolWebClientId: '7ubi1uv1nq94s2hetep2r5eo0r',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chocoautumn.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Cat environment
  chococat: {
    emoji: '🐱',
    name: 'Cat',
    appSyncUrl:
      'https://zzpfgp4d4jgsxd3h2rzmigqiee.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_D8hf8WdwJ',
    identityPoolId: 'eu-west-1:d1a8b9f5-d8fe-4b36-8c66-e853b02b6b14',
    userPoolWebClientId: '7rv30nf1mhqj2cffm2kkmr0ssu',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chococat.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Rizos environment
  chorizos: {
    emoji: '🍚',
    name: 'Rizos',
    appSyncUrl:
      'https://m734ewfxm5fphdjbgj4yobnpxe.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_6Y3b5Mjie',
    identityPoolId: 'eu-west-1:6a8b9c5a-f7d8-4e76-9b3c-2f8e7a4d5b1c',
    userPoolWebClientId: '3b7f8d9e1a4c6f2h5k8j9l1m3n',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chorizos.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Breakup environment
  chobreakup: {
    emoji: '💔',
    name: 'Breakup',
    appSyncUrl:
      'https://b7mklinglvb3fewkyihrqt2usy.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_895JzigBu',
    identityPoolId: 'eu-west-1:91e130ac-35f8-4b5b-a845-ab0f7f5c942d',
    userPoolWebClientId: '6f0f2j0tkpj6bcndvpjml0ggbl',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-chobreakup.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Dawn environment
  dawn: {
    emoji: '💰',
    name: 'Dawn',
    appSyncUrl:
      'https://c8nklmopqrst3uvwx4yz5a6b7c.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_D8wn9X1yZ',
    identityPoolId: 'eu-west-1:a9b8c7d6-e5f4-4321-b0a9-8d7c6b5a4e3f',
    userPoolWebClientId: '4h8k9l2m3n5p6q7r9s1t4u6v8w',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-dawn.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Platform infrastructure environment
  plinfra: {
    emoji: '👾',
    name: 'Platform Infrastructure',
    appSyncUrl:
      'https://3cdmblyg7rgj7h37htm5wjw2vy.appsync-api.eu-west-1.amazonaws.com/graphql',
    userPoolId: 'eu-west-1_rTRlQqKgh',
    identityPoolId: 'eu-west-1:c97da390-4e09-48fb-9fd0-72c92133d17b',
    userPoolWebClientId: '2r83c8nr18iv95q4nuevs8em0n',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-plinfra.auth.eu-west-1.amazoncognito.com',
    isProduction: false,
  },

  // Production environment (will be populated from AWS Parameter Store in production)
  choprd: {
    emoji: '🚔',
    name: 'Production',
    appSyncUrl: process.env.REACT_APP_GRAPHQL_ENDPOINT || '',
    userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || '',
    region: 'eu-west-1',
    oauthDomain: 'choco-admin-choprd.auth.eu-west-1.amazoncognito.com',
    isProduction: true,
  },
};

// Default environment for development
export const DEFAULT_ENVIRONMENT: EnvironmentKey = 'chostg';

// Production environment key
export const PRODUCTION_ENVIRONMENT: EnvironmentKey = 'choprd';
